module.exports = __webpack_public_path__ + "img/fuli.bca9a902.png";